exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".departments{\r\n    width: 95%;\r\n}\r\n.groupButton{\r\n    width: 100%;\r\n}\r\n.drp-menu{\r\n    width: 90%;\r\n}\r\n.item:hover{\r\n    background-color: grey;\r\n}\r\n.item{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/modals/addDepartments/add-departments.component.css
// module id = ../../../../../src/app/modals/addDepartments/add-departments.component.css
// module chunks = main